import { useEffect } from 'react';

export const get = () => {
  return window.document.title;
};

const BASE = get();

export const set = (value) => {
  window.document.title = value ? `${value} - ${BASE}` : BASE;
};

export const Title = ({ value }) => {

  useEffect(() => {
    set(value);
    return () => set();
  }, [value]);

  return <></>;
};